import React from "react";

const MessageContext = React.createContext(null);

if (process.env.NODE_ENV !== "production") {
  MessageContext.displayName = "MessageContext";
}

export default MessageContext;
